module.exports = __webpack_public_path__ + "src/img/Favicon.png";